import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ProgressSpinner } from "primereact/progressspinner";
import {
  genElObject,
  genElText,
  genElTextPassword,
  genElZirvuFileManager,
} from "../../../components/utils/EditorDialogElementGenerator";
import JabatanSelectorDialog from "../../../dialogs/selectors/JabatanSelectorDialog";
import { Divider } from "@mui/material";

const editTitle = "Edit Karyawan";
const addTitle = "Tambah Karyawan";

const KaryawanEditorDialog = (props) => {
  const {
    visible,
    onHide,
    onConfirm,
    loading,
    title,
    data,
    setData,
    addNewMode,
    error,
    setError,
  } = props;

  // dialog state
  const [showJabatanSelector, setShowJabatanSelector] = React.useState(false);

  /**
   * Validates the form data.
   *
   * @returns {boolean} - Returns true if the data is valid, otherwise false.
   * @returns {object} - Returns an object containing the error messages, format { field: message}.
   */
  const validate = () => {
    let valid = true;
    let newEror = {};

    const nik = data.nik ? data.nik.trim() : data.nik;
    if (nik === "" || nik === null || nik === undefined) {
      newEror = { ...newEror, nik: "NIK harus diisi" };
      valid = false;
    }

    const nama = data.nama ? data.nama.trim() : data.nama;
    if (nama === "" || nama === null || nama === undefined) {
      newEror = { ...newEror, nama: "Nama harus diisi" };
      valid = false;
    }

    const jabatan = data.data_jabatan;
    if (!jabatan) {
      newEror = { ...newEror, jabatan: "Jabatan harus diisi" };
      valid = false;
    }

    const username = data.data_user.username;
    if (username === "" || username === null || username === undefined) {
      newEror = { ...newEror, username: "User Name harus diisi" };
      valid = false;
    }

    const email = data.data_user.email;
    if (email === "" || email === null || email === undefined) {
      newEror = { ...newEror, email: "Email harus diisi" };
      valid = false;
    }

    const password = data.data_user.password;
    const cpassword = data.data_user.cpassword;

    if (password || cpassword) {
      if (password !== cpassword) {
        newEror = {
          ...newEror,
          "data_user.password": "Password & Konfirmasi tidak sama",
          "data_user.cpassword": "Password & Konfirmasi tidak sama",
        };
        valid = false;
      }
    }

    if (!valid) setError(newEror);

    return valid;
  };

  // handle UI event section

  const handleOnClickJabatan = () => {
    setShowJabatanSelector(true);
  };

  const handleOnConfirmJabatan = (event, datas) => {
    let selected;
    event.preventDefault();
    if (datas && datas.length > 0) {
      selected = datas[0];
      setData({ ...data, data_jabatan: selected, jabatan_id: selected.id });
      setShowJabatanSelector(false);
    }
    return selected;
  };

  /**
   * Generate Dialog Form Element
   *
   * various function to generate
   *
   * genElText({ field, name, data, setData, disabled, autoFocus, error })
   * genElTextPassword({ field, name, data, setData, disabled, autoFocus, error })
   * genElTextDropdown({ field, name, data, setData, options, disabled, autoFocus, error, optionLabel = "name" })
   * genElNumber({ field, name, data, setData, min_fraction_digits, max_fraction_digits, min, max, disabled, autoFocus, error })
   * genElNumberDropdown({ field, name, data, setData, options, disabled, autoFocus, error, optionLabel = "name" })
   * genElBoolean({ field, name, data, setData, labelTrue = "Ya", labelFalse = "Tidak", disabled, autoFocus, error })
   * genElDate({ field, name, data, setData, primeFormat, min, max, showTime, time, month, year, disabled, autoFocus, error })
   * genElObject({ field, name, value, onClick, selectorGenerator, disabled, autoFocus, error })
   */

  const elKode = genElText({
    field: "nik",
    name: "NIK",
    data,
    setData,
    error,
  });
  const elNama = genElText({
    field: "nama",
    name: "Nama",
    data,
    setData,
    error,
  });
  const elJabatan = genElObject({
    field: "jabatan",
    name: "Jabatan",
    value: data.data_jabatan ? data.data_jabatan.nama : "",
    onClick: handleOnClickJabatan,
  });
  const elUserName = genElText({
    field: "data_user.username",
    name: "User Name",
    data,
    setData,
    error,
  });
  const elUserEmail = genElText({
    field: "data_user.email",
    name: "Email",
    data,
    setData,
    error,
  });
  const elUserPassword = genElTextPassword({
    field: "data_user.password",
    name: "Password",
    data,
    setData,
    error,
  });
  const elUserCPassword = genElTextPassword({
    field: "data_user.cpassword",
    name: "Confirm Password",
    data,
    setData,
    error,
  });
  const elSignature = genElZirvuFileManager({
    field: "signature",
    name: "Tanda Tangan",
    data,
    setData,
    error,
  });

  const dialogFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        outlined
        onClick={props.onHide}
      />
      <Button
        label="Save"
        icon="pi pi-check"
        onClick={(e) => {
          const valid = validate();
          if (valid) {
            onConfirm(data);
          }
        }}
      />
    </React.Fragment>
  );

  return (
    <Dialog
      visible={visible}
      style={{ width: "45rem" }}
      breakpoints={{ "960px": "75vw", "641px": "90vw" }}
      header={addNewMode ? addTitle : editTitle}
      modal
      className={`p-fluid`}
      footer={dialogFooter}
      onHide={onHide}
    >
      <JabatanSelectorDialog
        title={"Pilih Jabatan"}
        visible={showJabatanSelector}
        onHide={() => setShowJabatanSelector(false)}
        onConfirm={handleOnConfirmJabatan}
      />

      <div className="col-start-center relative h-100">
        <div className={`row-start-start w-100 gap-3`}>
          <div className="col-start-start w-100 gap-3">
            {elSignature}
            {elKode}
            {elNama}
          </div>
          <Divider layout="vertical" className="h-[23.7rem]" />
          <div className="col-start-start w-full gap-3">
            {elJabatan}
            {elUserName}
            {elUserEmail}
            {elUserPassword}
            {elUserCPassword}
          </div>
        </div>
        {loading && (
          <div
            className={`col-center-center w-100  gap-2 absolute z-100 h-100 bg-black/20 rounded `}
          >
            <ProgressSpinner />
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default KaryawanEditorDialog;
